export default "__VITE_ASSET__7fa4dd56__"